export default __webpack_public_path__ + "assets/a544fd8cf64d82898e91eb55312d3efc.png";